<nb-select fullWidth [(selected)]="value" [disabled]="isDisabled" multiple
           [placeholder]="'Rolle auswählen'">
  <nb-option *ngFor="let tenantRole of tenantRoles()"
             [value]="tenantRole.id">
    {{tenantRole.name}}
  </nb-option>
</nb-select>
